import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { show, hide } from "redux-modal";
import { ButtonClose } from "./style";
import showDialog from "../../../utils/ShowDialog/ShowDialog";
import ConceptForm from "../sendConceptsForm/sendConceptsForm.container.jsx";

export const useWorkingPart = (refresh, isMultiple) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  useEffect(() => {
    // StopServices.getLastStop().then((result) => {
    //   setLastStop(result);
    // });
  }, []);

  const handlerClosePopup = (popupName) => {
    dispatch(hide(popupName));
  };

  const onSucesss = () => {
    if (refresh) {
      refresh();
    }
    handlerClosePopup("ModalForm");
  };

  const putConcepts = async (uuid, array, isMultiple, selectedNames ) => {
    dispatch(
      show("ModalForm", {
        body: (
          <>
            <div className="row mb-2">
              <div className="col-12 text-end">
                <ButtonClose
                  type="button"
                  onClick={() => handlerClosePopup("ModalForm")}
                >
                  <i className="fa-solid fa-xmark"></i>
                </ButtonClose>
              </div>
            </div>
            <div className="row justify-content-center mb-3">
              <div className="col-12">
                <ConceptForm
                  uuid={uuid}
                  array={array}
                  isMultiple={isMultiple}
                  selectedNames={selectedNames}
                  onSuccess={() => onSucesss()}
                />
              </div>
            </div>
          </>
        ),
      }),
    );
  };

  return {
    putConcepts,
  };
};
